import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Poster from '../poster/poster';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import { setElementClass } from '../../../utils/create_class_list_util';
import NewsletterSubscriber from './newsletter_subscriber';
import ReCaptcha from './recaptcha';

class NewsletterSignup extends NewsletterSubscriber {
  shouldComponentUpdate(nextProps, nextState) {
    const { state } = this;
    const hasError = nextState.error;
    const hasStatusChange = nextState.message !== state.message;
    const isLoading = nextState.disabled !== state.disabled;
    const hasEmailInputChange = nextState.email !== state.email;
    const shouldDisplayCaptchaChange =
      this.state.shouldDisplayReCaptcha !== nextState.shouldDisplayReCaptcha;
    return (
      hasError ||
      hasStatusChange ||
      isLoading ||
      hasEmailInputChange ||
      shouldDisplayCaptchaChange
    );
  }

  render() {
    const { assignedNewsletters, id, isAdvertorial } = this.props;
    const currentSite = this.props.config.site;
    const isPost = this.props.modifier === 'post';

    const newsletterTitle =
      get(this.props, 'title') ||
      `${get(assignedNewsletters, '[0].listName')} Newsletter`;
    const newsletterDeck = get(this.props, 'deck')
      ? ` ${get(this.props, 'deck')}`
      : ` ${get(assignedNewsletters, '[0].message')}`;

    const metadata = {
      title: 'Newsletter Signup',
      featured_image: { source: this.props.poster },
      noLazy: true,
      assetSizes: imageSizesLookup[3]
    };

    return (
      <form
        onSubmit={this.handleSubmit}
        className={`newsletter-signup newsletter-signup--${
          this.props.modifier
        }`}
      >
        <div
          className={`newsletter-signup__container${
            isAdvertorial ? ' newsletter-signup__container--advertorial' : ''
          }`}
        >
          {this.props.poster ? <Poster metadata={metadata} /> : ''}
          <p className="newsletter-signup__copy">
            <strong
              className={
                isPost
                  ? setElementClass('newsletter-signup', 'copy-title--post')
                  : setElementClass('newsletter-signup', 'copy-title--homepage')
              }
            >
              {newsletterTitle}
            </strong>
            {isPost ? '' : newsletterDeck}
          </p>
          <input
            className={`newsletter-signup__input
              ${this.state.error ? 'newsletter-signup__input--error' : ''}
              ${this.state.status ? 'newsletter-signup__input--success' : ''}
              ${this.state.disabled ? 'newsletter-signup__input--loading' : ''}
              `}
            name="email"
            type="email"
            onFocus={this.handleInputFocus}
            onChange={this.handleEmailUpdate}
            value={this.state.email}
            disabled={this.state.disabled}
            placeholder={
              get(this.statusMessages, [this.state.status]) ||
              'YOUR EMAIL ADDRESS'
            }
          />

          <button
            className={`newsletter-signup__button ${
              isPost ? 'newsletter-signup__button--post' : ''
            } newsletter-signup__button--${currentSite}
              ${this.state.disabled ? 'newsletter-signup__button--loading' : ''}
              `}
            disabled={this.state.disabled}
          >
            Sign Up
          </button>
          {this.state.shouldDisplayReCaptcha ? (
            <div className="newsletter-signup__recaptcha">
              <ReCaptcha
                verifyCallback={this.handleVerify}
                id={id || 'fastcompanyhomepage'}
              />
            </div>
          ) : (
            ''
          )}
          {this.props.hideCheckBox || get(assignedNewsletters, 'length') < 2 ? (
            ''
          ) : (
            <div className="newsletter-signup__checkbox-option">
              <div className="newsletter-signup__checkbox-container">
                <div className="newsletter-signup__checkbox-wrapper">
                  <input
                    className="newsletter-signup__checkbox"
                    type="checkbox"
                    id="special-offers"
                    name={get(assignedNewsletters, '[1].listId')}
                    onChange={this.handleUpdate}
                    defaultChecked={true}
                  />
                </div>
                <label
                  className="newsletter-signup__label"
                  htmlFor="special-offers"
                >
                  {get(assignedNewsletters, '[1].message')}
                </label>
              </div>
              <a
                href="//www.fastcompany.com/newsletters"
                className="newsletter-signup__newsletter-page-link"
              >
                See All Newsletters
              </a>
            </div>
          )}
        </div>
      </form>
    );
  }
}

NewsletterSignup.defaultProps = {
  modifier: '',
  poster: '',
  hideCheckBox: false,
  id: '',
  isAdvertorial: false
};

NewsletterSignup.propTypes = {
  modifier: PropTypes.string,
  currentSite: PropTypes.string.isRequired,
  assignedNewsletters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  poster: PropTypes.string,
  hideCheckBox: PropTypes.bool,
  isAdvertorial: PropTypes.bool,
  id: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  const newslettersConfig = get(state, 'config.newsletters');
  const newslettersBySlug = get(newslettersConfig, 'listsBySlug');
  const newsletterDictionary = get(newslettersConfig, 'listsById');

  const assignedNewsletters = ownProps.newsletters;
  return {
    config: state.config,
    currentSite: state.config.site,
    assignedNewsletters: assignedNewsletters.map(
      function processAssignedNewsletters(newsletter) {
        const newsletterNameProp = newsletter.list;
        const listId = get(newslettersBySlug, newsletterNameProp);
        const found = newsletterDictionary[listId];
        return {
          listName: get(found, 'listName'),
          listId,
          message: get(found, 'short')
        };
      }
    )
  };
}

export default connect(mapStateToProps)(NewsletterSignup);
